import './App.scss';
import GameArea from './GameArea';
import GameWindow from '../components/game-window';
import imgLogo from './assets/logo.png'
import Ticket from '../components/ticket';

// Computes for the number of tickets based on the score.
const getNumTickets = bestScore => {
  if ( bestScore >= 110 ) {
    return 50
  } else if ( bestScore >= 90 ) {
    return 20
  } else if ( bestScore >= 70 ) {
    return 10
  } else if ( bestScore >= 40 ) {
    return 5
  } else if ( bestScore >= 10 ) {
    return 3
  } else if ( bestScore >= 4 ) {
    return 1
  } 
  return 0
}

function App() {
  const info = props => {
    const onReset = () => {
      props.setEmail( '' )
    }

    return (
      <>
        <img src={ imgLogo } alt="Flappy Block Logo" />
        <div>Pass obstacles to earn points. Press SPACE or click to fly. Your highest score will earn you tickets <Ticket /> for our Raffle!</div>
        <hr />
        <div>4 pts = 1 <Ticket /></div>
        <div>10 pts = 3 <Ticket /></div>
        <div>40 pts = 5 <Ticket /></div>
        <div>70 pts = 10 <Ticket /></div>
        <div>90 pts = 20 <Ticket /></div>
        <div>110 pts = 50 <Ticket /></div>
        <hr />
        <div>Playing as { props.email } ({ props.nick.toUpperCase() }) <a href="#0" role="button" onClick={ onReset } style={{ color: '#fe5b2b'}}>change</a></div>
        <div>Your best score: { props.bestScore }</div>
        <div>Your tickets: { props.tickets } <Ticket /></div>
        <div>Games played: { props.numGames }</div>
      </>
    )
  }

  const game = props => {
    return <GameArea { ...props } />
  }

  return (
    <GameWindow 
      game="FLAPPY_BLOCK"
      renderInfo={ info }
      renderGame={ game }
      // bestScoreFunc // function to get the best score out of all the current player's games. see ../components/game-window.js
      ticketNumFunc={ getNumTickets } // func to get the number of tickets based on the player's highest score. see ../components/game-window.js
      // rankCheckFunc // function to find the rank of the current score from all the leaderboard scores. see ../components/game-window.js
    />
  );
}

export default App;
